import { Component } from '@angular/core';
import { BlockListComponent } from 'components/layout/blocklist/blocklist.component';
import { ViewTaskflowComponent } from 'components/task/taskflow/view-taskflow.component';
import { CredentialType } from 'enums/CredentialType';
import { TaskActionType } from 'enums/TaskActionType';
import { OrderOnboardingViewModel } from 'models/generated/Models.OrderOnboardingView';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { TaskService } from 'services/task.service';

@Component({
	selector: 'order-onboarding-list',
	templateUrl: './order-onboarding-list.component.html',
	imports: [Layout, BlockListComponent, TranslatePipe]
})
@ComponentUrl('order-onboarding-list')
@CredentialRequired(CredentialType.BetaUserAccess)
export class OrderOnboardingListComponent {

	orderOnboardingTaskflows: OrderOnboardingViewModel[] = [];

	constructor(private readonly taskService: TaskService, private readonly navigation: NavigationService) {
		taskService.getOrderOnboardingTaskflows().then(orderOnboardingViews => {
			this.orderOnboardingTaskflows = orderOnboardingViews;
		});
	}

	selectOnboardingflow(taskflowId: string) {
		this.taskService.getTaskflow(taskflowId).then(taskflow => {
			this.navigation.refreshView(ViewTaskflowComponent).then(view => {
				view.taskflowId = taskflowId;

				var qualificationCall = taskflow.taskActions.find((ta) => ta.completed == undefined && ta.type === TaskActionType.qualificationCall);
				if (qualificationCall) view.selectedActionId = qualificationCall.id;
				else {
					const productLaunchAction = taskflow.taskActions.find(ta => ta.type === TaskActionType.productLaunch);
					if (productLaunchAction) view.selectedActionId = productLaunchAction.id;
				}
			});
		});
	}
}
